import fallbackFeatureFlag from '/src/assets/featureFlag.json';
import { getCookieChatbot, setCookieByHoursChatbot } from '/src/utils/cookiesUtils.js';

export const getFeatureFlagsChatbot = (accessToken, predicate = (response) => {}) => {
  // verify if the feature flag is inside the cookie
  if (!accessToken || accessToken === 'null') {
    // if not, use the fallback feature flag
    predicate(fallbackFeatureFlag);
    return;
  }
  const responseCookie = getCookieChatbot('featureFlag');
  if (responseCookie) {
    predicate(JSON.parse(responseCookie));
    return;
  }

  // if not fetch it from the server and save for 3 hours
  fetch(`${import.meta.env.VITE_APP_API_URL}/api/v1/feature-flag`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
  })
    .then(response => {
      if (response.ok && response.status === 200) {
        return response.json().then((responseData) => {
          setCookieByHoursChatbot('featureFlag', JSON.stringify(responseData), 3);
          predicate(responseData);
        }).catch((parseError) => {
          console.error('Error parsing feature flag response:', parseError);
          predicate(fallbackFeatureFlag);
        });
      } else {
        // Handle non-200 status codes (4xx, 5xx, etc.)
        console.error(`Error fetching feature flags: HTTP ${response.status} ${response.statusText}`);
        return response.text().then(() => {
          // Use fallback even if response body exists
          predicate(fallbackFeatureFlag);
        }).catch(() => {
          predicate(fallbackFeatureFlag);
        });
      }
    })
    .catch(error => {
      // Handle network errors, CORS errors, etc.
      console.error('Error fetching feature flags:', error);
      predicate(fallbackFeatureFlag);
    });
}
